import moment from "moment";

export function getHumanReadableDateDiff(date1, date2) {
  const start = moment(date1);
  const end = moment(date2);

  const years = end.diff(start, "years");
  start.add(years, "years");

  const months = end.diff(start, "months");
  start.add(months, "months");

  const days = end.diff(start, "days");

  const result: string[] = [];
  if (years > 0) result.push(`${years} year${years > 1 ? "s" : ""}`);
  if (months > 0) result.push(`${months} month${months > 1 ? "s" : ""}`);
  if (days > 0) result.push(`${days} day${days > 1 ? "s" : ""}`);

  return result.join(", ");
}

export const getPrintApplicationTooltip = ({
  startedAt,
  isPolling
}: {
  startedAt: string | undefined;
  isPolling: boolean;
}) => {
  if (!startedAt) return "Applicant has not started their application";
  if (isPolling) return "Preparing documents for print...";
  return "";
};
